export default __webpack_public_path__ + "static/media/notAvailable.36534cb9.png";